'use client';

import { defaultInputLabel } from "../SearchField.data.js";
function parseProps({
  disabled,
  a11yLabel: a11yLabelProp,
  className,
  ...inputProps
}) {
  const a11yLabel = a11yLabelProp || defaultInputLabel;
  const formControlProps = {
    disabled,
    a11yLabel,
    className,
    label: {
      children: a11yLabel
    },
    hiddenLabel: true
  };
  return {
    formControlProps,
    inputProps
  };
}
export {
  parseProps
};
